import {Dimensions} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Modal from 'react-native-modal';
import Feather from 'react-native-vector-icons/Feather';
import {ParcelaStatusVisual} from '../../../../services/creditoMova';

const {height: screenHeight} = Dimensions.get('window');

//@ts-ignore
export const Container = styled(Modal)`
  justify-content: flex-end;
  margin: 0;
`;

export const Sheet = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  max-height: ${screenHeight * 0.85}px;
  padding-bottom: ${RFValue(16)}px;
`;

export const Handle = styled.View`
  width: 40px;
  height: 4px;
  border-radius: 2px;
  background-color: ${({theme}) => theme.colors.border};
  align-self: center;
  margin-top: ${RFValue(10)}px;
  margin-bottom: ${RFValue(16)}px;
`;

export const SheetHeader = styled.View`
  padding: 0 ${RFValue(20)}px;
  margin-bottom: ${RFValue(16)}px;
`;

export const SheetTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(17)}px;
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(2)}px;
`;

export const SheetSubtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
`;

export const ScrollContent = styled.ScrollView`
  padding: 0 ${RFValue(20)}px;
`;

export const ParcelaCard = styled.View<{status: ParcelaStatusVisual}>`
  border-radius: ${RFValue(12)}px;
  border-width: 1px;
  border-color: ${({theme, status}) => {
    if (status === 'em_atraso') {return theme.colors.attention;}
    if (status === 'vence_hoje') {return theme.colors.gold;}
    return theme.colors.border;
  }};
  background-color: ${({theme, status}) => {
    if (status === 'em_atraso') {return theme.colors.attention_opacity;}
    if (status === 'vence_hoje') {return theme.colors.gold_opacity;}
    return theme.colors.price_card;
  }};
  padding: ${RFValue(14)}px;
  margin-bottom: ${RFValue(10)}px;
`;

export const ParcelaRow = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ParcelaLeft = styled.View`
  flex: 1;
`;

export const ParcelaNumber = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(2)}px;
`;

export const ParcelaDate = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text};
`;

export const ParcelaRight = styled.View`
  align-items: flex-end;
  gap: ${RFValue(6)}px;
`;

export const ParcelaValue = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const StatusPill = styled.View<{status: ParcelaStatusVisual}>`
  padding: ${RFValue(3)}px ${RFValue(8)}px;
  border-radius: ${RFValue(20)}px;
  background-color: ${({theme, status}) => {
    if (status === 'em_atraso') {return theme.colors.attention;}
    if (status === 'vence_hoje') {return theme.colors.gold;}
    if (status === 'paga') {return theme.colors.black;}
    return theme.colors.primary;
  }};
`;

export const StatusText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.buttonTitle};
`;

export const EncargosBreakdown = styled.View`
  margin-top: ${RFValue(10)}px;
  padding-top: ${RFValue(10)}px;
  border-top-width: 1px;
  border-top-color: ${({theme}) => theme.colors.border};
`;

export const EncargosRow = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${RFValue(4)}px;
`;

export const EncargosLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text};
`;

export const EncargosValue = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.attention};
`;

export const EncargosDivider = styled.View`
  height: 1px;
  background-color: ${({theme}) => theme.colors.border};
  margin: ${RFValue(4)}px 0;
`;

export const ButtonWrapper = styled.View`
  margin-top: ${RFValue(10)}px;
`;

export const LoadingWrapper = styled.View`
  padding: ${RFValue(40)}px 0;
  align-items: center;
`;

export const UnavailableContainer = styled.View`
  align-items: center;
  padding: ${RFValue(40)}px ${RFValue(24)}px;
`;

export const UnavailableIcon = styled(Feather)`
  font-size: ${RFValue(36)}px;
  color: ${({theme}) => theme.colors.text};
  margin-bottom: ${RFValue(12)}px;
`;

export const UnavailableTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  text-align: center;
  margin-bottom: ${RFValue(6)}px;
`;

export const UnavailableText = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  text-align: center;
  line-height: ${RFValue(18)}px;
`;
